import "./GarageDoorRemoteProgrammingSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import Garage from "./sections/Garage";
import GarageAutomation from "./sections/GarageAutomation";
import GarageWhyUs from "./sections/GarageWhyUs";
import GarageFeatures from "./sections/GarageFeatures";
import Testimonials from "./sections/Testimonials";
import Remotefaq from "./sections/Remotefaq";
import GarageValues from "./sections/GarageValues";
import ServiceCoverageMap from "./sections/ServiceCoverageMap";
import Footer from "./sections/Footer";
import GarageCta from "./sections/GarageCta";
export default function GarageDoorRemoteProgrammingSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageServices />
      <Garage />
      <GarageAutomation />
      <GarageWhyUs />
      <GarageFeatures />
      <Testimonials />
      <Remotefaq />
      <ServiceCoverageMap />
      <GarageValues />
      <GarageCta />
      <Footer />
    </div>;
}